import { types } from 'mobx-state-tree';

export const BillingSummary = types.model('BillingSummary', {
  id: types.identifier,
  hours: types.optional(types.string, '0'),
  billing: types.optional(types.string, '0')
});

export default BillingSummary;
